export default __webpack_public_path__ + "static/NotoSansThai-Bold-1505f808cf51b6508737788352112e96.ttf";